module.exports = __webpack_public_path__ + "static/img/core-left.68f2274.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/smart/core-left.png
// module id = Zd9D
// module chunks = 0 2